import React from "react";
import "./smartDashboards.scss";

//Imagens:
import ImgSmartDashboards from "../../../../assets/interactiveDashboards/smartDashboards.png";
import { useTranslation } from "react-i18next";

function SmartDashboards() {

  const {t} = useTranslation()

  return (
    <div className="container-smart-dashboards">
      <div className="img-smart-dashboards">
        <img src={ImgSmartDashboards} alt="" />
      </div>
      <div className="texts-smart-dashboards">
        <h1>{t("interactive_dashboards.smart_dashboards.title")}</h1>
        <p>{t("interactive_dashboards.smart_dashboards.section_text")}</p>
        <a href="/form" style={{textDecoration:"none"}}>
          <button id="btn-smart-dashboards">{t("buttons.demo_btn_text")}</button>
        </a>
      </div>
    </div>
  );
}

export default SmartDashboards;
